// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-toolbar {
  display: flex;
  align-items: center;
  background: transparent;
  border-top: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
}
.editor-toolbar .icon-btn-group {
  padding: 4px 8px 3px;
  height: 39px;
  width: auto;
  border-left: 1px solid #e8e8e8;
}
.editor-toolbar .icon-btn {
  display: inline-block;
  height: 32px;
  width: auto;
  min-width: 32px;
  margin: 0;
  text-align: center;
  padding: 0 7px;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 3px 3px;
  font-size: 16px;
  cursor: pointer;
  color: #595959;
  outline: none;
  line-height: 32px;
}
.editor-toolbar .icon-btn:hover {
  border: 1px solid transparent;
  background-color: #f5f5f5;
}
.editor-toolbar .icon-btn-active {
  background-color: #e8e8e8;
  border: 1px solid transparent;
}
.editor-toolbar .popup-action {
  position: relative;
}
.editor-toolbar .popup-action .popup-container {
  position: absolute;
  left: 0;
}
.slate-editor-body {
  border: 1px solid #e8e8e8;
  min-height: 300px;
  padding: 5px 10px;
}
.slate-editor-body.readonly {
  border: none;
  min-height: 0;
  padding: 0;
}
.slate-editor-body ul,
.slate-editor-body li {
  list-style: inherit;
}
.slate-editor-body ul,
.slate-editor-body ol {
  padding-inline-start: 40px;
}
.icon-strikethrough {
  font-size: 18px;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/libs/slate-editor/index.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,+BAAA;AACF;AANA;EAQI,oBAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;AACJ;AAZA;EAeI,qBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AAAJ;AAEI;EACE,6BAAA;EACA,yBAAA;AAAN;AAGI;EACE,yBAAA;EACA,6BAAA;AADN;AArCA;EA2CI,kBAAA;AAHJ;AAxCA;EA8CM,kBAAA;EACA,OAAA;AAHN;AAQA;EACE,yBAAA;EACA,iBAAA;EACA,iBAAA;AANF;AAQE;EACE,YAAA;EACA,aAAA;EACA,UAAA;AANJ;AAFA;;EAYI,mBAAA;AANJ;AANA;;EAgBI,0BAAA;AANJ;AAaA;EACE,eAAA;EACA,iBAAA;AAXF","sourcesContent":[".editor-toolbar {\n  display: flex;\n  align-items: center;\n  background: transparent;\n  border-top: 1px solid #e8e8e8;\n  border-right: 1px solid #e8e8e8;\n\n  .icon-btn-group {\n    padding: 4px 8px 3px;\n    height: 39px;\n    width: auto;\n    border-left: 1px solid #e8e8e8\n  }\n\n  .icon-btn {\n    display: inline-block;\n    height: 32px;\n    width: auto;\n    min-width: 32px;\n    margin: 0;\n    text-align: center;\n    padding: 0 7px;\n    background-color: transparent;\n    border: 1px solid transparent;\n    border-radius: 3px 3px;\n    font-size: 16px;\n    cursor: pointer;\n    color: #595959;\n    outline: none;\n    line-height: 32px;\n\n    &:hover {\n      border: 1px solid transparent;\n      background-color: #f5f5f5;\n    }\n\n    &-active {\n      background-color: #e8e8e8;\n      border: 1px solid transparent;\n    }\n  }\n\n  .popup-action {\n    position: relative;\n\n    .popup-container {\n      position: absolute;\n      left: 0;\n    }\n  }\n}\n\n.slate-editor-body {\n  border: 1px solid #e8e8e8;\n  min-height: 300px;\n  padding: 5px 10px;\n\n  &.readonly {\n    border: none;\n    min-height: 0;\n    padding: 0;\n  }\n\n  ul, li {\n    list-style: inherit;\n  }\n\n  ul, ol {\n    padding-inline-start: 40px;\n  }\n\n\n\n}\n\n.icon-strikethrough {\n  font-size: 18px;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
